<!--
 * @Author: scg
 * @Date: 2022-01-17 16:18:42
 * @LastEditTime: 2022-02-09 09:05:11
 * @LastEditors: scg
 * @Description:
-->
<template>
<div  class="fff">
<div class="page_title">Choose the Device You want to Monitor</div>
  <div class="page_bo_li" @click="$router.push({path: '/Manufacturer'})">
    <img src="@/assets/img/a.png" alt="" class="system_logo">
    <!-- <i  class="u-iconfont uicon-android-fill system_logo"></i> -->
    <img src="@/assets/img/go_r.png" alt="" class="system_more">
    <div class="system_title">Android</div>
    <div class="system_con">Samsung, Huawei, Xiaomi...</div>
  </div>
  <div class="page_bo_li" @click="$router.push({path: '/Enter'})">
    <img src="@/assets/img/i.png" alt="" class="system_logo">
    <img src="@/assets/img/go_r.png" alt="" class="system_more">
    <div class="system_title">Apple,ios</div>
    <div class="system_con">Any Apple iPhone or iPad</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff{width:100%;position:absolute;height:100%;background:#fff;overflow:hidden}
.page_bo_li{margin-bottom:20px;position:relative;padding:25px 0}
/* .system_logo{float:left;width:46px;margin:0 15px 0 20px} */
.system_more{position:absolute;width:16px;height:16px;right:25px;top:40px}
.system_title{font-size:14px;height:16px;line-height:16px;font-weight:700;margin-bottom:5px}
.system_con{font-size:13px;height:20px;line-height:20px;color:grey}
</style>



// WEBPACK FOOTER //
// src/components/Choose.vue